// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4c0d41a2","977":"fa89d669"}[chunkId] + ".chunk.js";
};